import { useContext } from 'react';

import { BaseModalContext, type BaseModalType } from './BaseModalProvider';

export const useModalContext = (contextKey: BaseModalType | string, openAsDrawer?: boolean) => {
    const { state, openModal, closeModal } = useContext(BaseModalContext);

    const handleOpenModal = () => (openModal ? openModal(contextKey) : undefined);
    const handleCloseModal = () => (closeModal ? closeModal(contextKey) : undefined);

    const currentModalState = state[contextKey];

    return {
        state: {
            show: currentModalState?.show ?? false,
            drawer: openAsDrawer ?? false,
        },
        openModal: handleOpenModal,
        closeModal: handleCloseModal,
    };
};
